import { Box, HStack, Icon, Link, Spacer } from '@chakra-ui/react';
import { IconChevronBottom } from 'central-icons/IconChevronBottom';
import { IconChevronTop } from 'central-icons/IconChevronTop';
import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import type { RouteNavConfig } from '@revelio/auth';

export interface SubNavDropdownProps {
  item: RouteNavConfig;
  onSubNavClose: () => void;
  isParentOpen?: boolean;
}

export function SubNavDropdown({
  item: { name = '', children = [] },
  onSubNavClose,
  isParentOpen,
}: SubNavDropdownProps) {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (!isParentOpen) {
      setIsOpen(false);
    }
  }, [isParentOpen]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: migrated from develop
  useEffect(() => {
    const pathname =
      location.pathname[0] === '/'
        ? location.pathname.slice(1)
        : location.pathname;

    setIsOpen(children.some((child) => child.path === pathname));
  }, [isParentOpen, children, location.pathname, name]);

  return (
    <>
      {!!children.length && (
        <Box
          onClick={() => setIsOpen((prev) => !prev)}
          fontSize="md"
          padding="8px 12px"
          marginTop="8px"
          color="text.primary"
          borderRadius="md"
          width="100%"
          _hover={{ background: 'green.100' }}
        >
          <HStack>
            <div>{name}</div>
            <Spacer />
            <Icon
              as={isOpen ? IconChevronTop : IconChevronBottom}
              boxSize={5}
              color="text.primary"
            />{' '}
          </HStack>
        </Box>
      )}
      {isOpen && (
        // biome-ignore lint/complexity/noUselessFragments: migrated from develop
        <>
          {children.map((child, i) => {
            return (
              <Link
                as={NavLink}
                to={child.path as string}
                key={i}
                onClick={() => onSubNavClose()}
                fontSize="md"
                padding="8px 12px"
                paddingLeft="24px"
                marginTop="8px"
                color="text.primary"
                borderRadius="md"
                width="100%"
                _hover={{ background: 'green.100' }}
              >
                {child.name}
              </Link>
            );
          })}
        </>
      )}
    </>
  );
}

export default SubNavDropdown;
